import React, { createContext, useState } from "react";
import useOrders from "../../hooks/useOrders";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import PaymentMethod from "../flight/PaymentMethod";
import Modal1 from "../DIsplay/Modal/Modal1";
import CancelTicket from "../../pages/Orders/CancelTicket";
import CancelOrder from "../../pages/Orders/cancelOrder";
import IssueTicket from "../../pages/Orders/IssueTicket";
import TicketVoid from "../../pages/Orders/VoidTicket";
import Rebook from "../flight/book/Rebook";
import { URLencode } from "../../utils/url";
import OrderStatus from "./OrderStatus";
import segmentFlights from "../../utils/flight/segmentFlights";
import moment from "moment";
import OrderMenu from "./menu/OrderMenu";
import SendInvoiceToCustomer from "./SendInvoiceToCustomer";
import { Modal3 } from "../DIsplay/Modal/Modal3";
import FlightPaymentOptions from "../../pages/Orders/Flight/Book/FlightPaymentOptions";

export const ActionContext = createContext();

function OrderList({ perPage = 10, reload }) {
  const { getOrders } = useOrders();
  const [orders, ogData] = getOrders() || [[], []];

  const [openPayment, setOpenPayment] = useState(false);
  const [booking, setBooking] = useState(false);
  const [openCancelTicket, setOpenCancelTicket] = useState(false);
  const [openCancelOrder, setOpenCancelOrder] = useState(false);
  const [openIssueTicket, setOpenIssueTicket] = useState(false);
  const [openVoidTicket, setOpenVoidTicket] = useState(false);
  const [openRebook, setOpenRebook] = useState(false);
  const [openSendInvoice, setOpenSendInvoice] = useState(false);

  const { ticketsPage: page } = useSelector((state) => state.order);
  const offset = ((page || 1) - 1) * perPage;

  function objectToQueryString(obj, prefix = "") {
    const str = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const k = prefix
          ? `${prefix}[${encodeURIComponent(key)}]`
          : encodeURIComponent(key);
        const v = obj[key];
        str.push(
          typeof v === "object" && v !== null
            ? objectToQueryString(v, k) // Recursion for nested objects
            : `${k}=${encodeURIComponent(v)}`
        );
      }
    }
    return str.join("&");
  }

  function redirectWithQuery(obj, baseUrl) {
    const queryString = objectToQueryString(obj);
    const fullUrl = `${baseUrl}?${queryString}`;
    window.open(fullUrl, "_blank"); // Use '_self' to open in the same tab
  }

  function searchHotel(obj) {
    const booking = obj?.flightBooking?.at(0);
    const flights = segmentFlights(booking?.flights);

    let payload = {
      latitude: 0.1,
      longitude: 0.1,
      start_date: moment(flights?.at(0)?.at(-1)?.arrivalDate)?.format(
        "YYYY-MM-DD"
      ),
      end_date: flights?.at(1)
        ? moment(flights?.at(1)?.at(0)?.departureDate)?.format("YYYY-MM-DD")
        : moment(flights?.at(0)?.at(-1)?.arrivalDate)
            ?.add(2, "days")
            ?.format("YYYY-MM-DD"),
      range: 200,
      suppliers: ["StayX2", "StayX3"],
      city: flights?.at(0)?.at(-1)?.departureLocationName,
      rooms: Array.from(
        { length: booking?.adult?.passengerCount },
        (obj, i) => ({
          adults: booking?.adult?.passengerCount,
          children: booking?.child?.passengerCount ? i + 1 : 0,
          units: 1,
        })
      ),
    };

    redirectWithQuery(payload, "/accommodation/results");
    console.log(obj, payload);
  }

  function searchTour(obj) {
    let payload = {
      destinationId: "66f006c7b15e47be90a55eea",
      destinationName: "Lagos",
      suppliers: ["TourX1"],
      populate: false,
      limit: 10,
    };
  }

  return (
    <div>
      <ActionContext.Provider
        value={{
          reload,
          openPayment,
          setOpenPayment,
          booking,
          setBooking,
          openCancelTicket,
          setOpenCancelTicket,
          openCancelOrder,
          setOpenCancelOrder,
          openIssueTicket,
          setOpenIssueTicket,
          openVoidTicket,
          setOpenVoidTicket,
          openRebook,
          setOpenRebook,
          searchHotel,
          searchTour,
          setOpenSendInvoice,
        }}
      >
        <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-3 p-1">
          {/* {orders?.slice(offset,offset+perPage).map((order, index) => (
            <Order key={index} order={order} og={ogData?.slice(offset,offset+perPage)?.at(index)} />
          ))} */}
          {orders?.slice(0, perPage).map((order, index) => (
            <Order
              key={index}
              order={order}
              og={ogData?.slice(0, perPage)?.at(index)}
            />
          ))}
        </div>
      </ActionContext.Provider>

      <ActionHandles
        {...{ reload }}
        {...{ openPayment, setOpenPayment }}
        {...{ booking, setBooking }}
        {...{ openCancelOrder, setOpenCancelOrder }}
        {...{ openCancelTicket, setOpenCancelTicket }}
        {...{ openIssueTicket, setOpenIssueTicket }}
        {...{ openVoidTicket, setOpenVoidTicket }}
        {...{ openRebook, setOpenRebook }}
        {...{ openSendInvoice, setOpenSendInvoice }}
      />
    </div>
  );
}

function ActionHandles({
  reload,
  openPayment,
  setOpenPayment,
  booking,
  setBooking,
  openCancelTicket,
  setOpenCancelTicket,
  openCancelOrder,
  setOpenCancelOrder,
  openIssueTicket,
  setOpenIssueTicket,
  openVoidTicket,
  setOpenVoidTicket,
  openRebook,
  setOpenRebook,
  openSendInvoice,
  setOpenSendInvoice,
}) {
  return (
    <div>
      <Modal1 open={openPayment} setOpen={setOpenPayment}>
        {/* <PaymentMethod
          callback={() => {
            reload && reload();
            setOpenPayment(false);
          }}
          flightBookingId={openPayment}
          hide={["booklater"]}
          expand
        /> */}
        <FlightPaymentOptions
          booking={booking}
          callback={() => {
            reload && reload();
            setOpenPayment(false);
          }}
          onPayLater={() => {
            setOpenPayment(false);
          }}
        />
      </Modal1>

      <CancelOrder
        open={openCancelOrder}
        setOpen={setOpenCancelOrder}
        callback={() => {
          reload && reload();
          setOpenCancelOrder(false);
        }}
      />

      <Modal1 open={openCancelTicket} setOpen={setOpenCancelTicket}>
        <CancelTicket
          data={openCancelTicket}
          callback={() => {
            reload && reload();
            setOpenCancelTicket(false);
          }}
          close={() => setOpenCancelTicket(false)}
        />
      </Modal1>

      <Modal1 open={openIssueTicket} setOpen={setOpenIssueTicket}>
        <IssueTicket
          data={openIssueTicket}
          callback={() => {
            reload && reload();
            setOpenIssueTicket(false);
          }}
          close={() => setOpenIssueTicket(false)}
        />
      </Modal1>

      <Modal1 open={openVoidTicket} setOpen={setOpenVoidTicket}>
        <TicketVoid
          data={openVoidTicket}
          callback={() => {
            reload && reload();
            setOpenVoidTicket(false);
          }}
          close={() => setOpenVoidTicket(false)}
        />
      </Modal1>

      <Modal1 open={openRebook} setOpen={setOpenRebook}>
        <Rebook data={openRebook} />
      </Modal1>

      <Modal3
        title="Send Invoice"
        open={openSendInvoice}
        setOpen={setOpenSendInvoice}
      >
        <SendInvoiceToCustomer
          id={openSendInvoice}
          close={() => setOpenSendInvoice(false)}
          callback={() => setOpenSendInvoice(false)}
        />
      </Modal3>
    </div>
  );
}

export default OrderList;

const Order = ({ order, og }) => {
  const bookingData = og?.flightBooking?.at(0);
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full flex  justify-between bg-white p-4 gap-3">
      <div className="flex flex-col md:flex-row justify-between flex-1 overflow-clip max-w-[calc(100%-62px)]">
        {order?.map(({ elements, cover, width }, index) => (
          <div
            className={`w-full ${width || "flex-1"} ${
              !open && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              open && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            <div className={`hidden sm:flex flex-col `}>
              {elements?.map((element, idx) => (
                <OrderContent element={element} key={idx} booking={og} />
              ))}
            </div>
            <div className="flex flex-col sm:hidden">
              {!cover
                ? elements?.map((element, idx) => (
                    <OrderContent element={element} key={idx} booking={og} />
                  ))
                : cover}
            </div>
          </div>
        ))}
      </div>
      <div
        className={`${
          bookingData?.status || og?.status ? "flex" : "hidden"
        } flex-col gap-4 items-center min-w-[50px]`}
      >
        <OrderMenu og={og} order={order} />
        <div
          className="flex md:hidden sticky top-10"
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <img
              src="/IconChevronUp.svg"
              alt=""
              className="w-5 object-contain"
            />
          ) : (
            <img
              src="/IconChevronDown.svg"
              alt=""
              className="w-5 object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const OrderContent = ({ element, booking }) => {
  if (element?.render) return element?.render();

  switch (element.type) {
    case "title":
      return <Title value={element.value} />;
    case "copy":
      return <Copy value={element.value} render={element?.renderValue} />;
    case "tag":
      return <Tag element={element} />;
    case "time":
      return <Time value={element?.value} />;
    case "status":
      return <OrderStatus value={element?.value} />;
    case "hotelLink":
      return <HotelLink value={element?.value} booking={booking} />;
    default:
      return <Text value={element.value} />;
  }
};

const Text = ({ value }) => {
  return (
    <span className="text-sm mb-2">
      {typeof value === "string" ? value?.slice(0, 100) : ""}
      {value?.length > 100 ? "..." : ""}
    </span>
  );
};

export const Title = ({ value }) => {
  return <span className="text-sm text-[#6D7C94] mb-2">{value}</span>;
};

export const Copy = ({ value, render }) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(value);
      enqueueSnackbar("Copied to clipboard!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to copy to clipboard!", { variant: "error" });
    }
  };
  return (
    <div
      className="flex gap-1 items-center mb-2 cursor-pointer"
      onClick={handleCopy}
    >
      <span className="text-xs text-primary1">{render ? render() : value}</span>
      <img src="/IconCopy.svg" alt="" />
    </div>
  );
};

export const Tag = ({ element }) => {
  return (
    <div className={`rounded-md `}>
      <span
        className={`${element?.color} ${element?.background} text-xs font-bold px-2 py-1 rounded-md ${element?.className}`}
      >
        {element?.value}
      </span>
    </div>
  );
};

export const Time = ({ value }) => {
  return (
    <div className="flex gap-1 items-center mb-2 cursor-pointer">
      <img src="/IconClock1.svg" alt="" />
      <span className="text-xs">{value}</span>
    </div>
  );
};

export const HotelLink = ({ value, booking }) => {
  const url = () => {
    let parameters = {
      bookingId: booking?._id,
      bookId: booking?.bookingId,
      bookingDate: booking?.createdAt,
      price: booking?.amount,
      name: booking?.holdBookingRes?.name,
    };
    return `/accommodation/confirmation?${URLencode(parameters)}`;
  };

  return (
    <a
      className="text-sm mb-2 text-primary1"
      href={url()}
      target="_blank"
      rel="noreferrer"
    >
      {value}
    </a>
  );
};

export const allStatuses = [
  "Not Paid",
  "Pending",
  "Paid",
  "Failed",
  "Booked",
  "Ticket issued",
  "Issued",
  "PendingTicketIssue",
  "AwaitingAdmin",
  "Expired",
  "AutoCanceled",
  "Cancelled",
  "CustomerPaid",
  "TicketCanceled",
  "Refunded",
  "TicketCancelationRequested",
];
